// extracted by mini-css-extract-plugin
export var rectangularButton = "rectangular-button-module--rectangularButton--e2e58";